import template from './index.html.twig';

Shopware.Component.register('moorl-template-mapping-info', {
    template,
});
